import React, { useContext, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { DeleteOutlined, EditOutlined, VisibilityOutlined } from '@mui/icons-material';
import { CustomWarningDelete } from '../../CustomWarningDelete';
import { UpdateChannelForm } from './UpdateChannelForm';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { AuthContext } from '../../../contexts/AuthContext';
import { ModalsContext } from '../../../contexts/ModalsContext';
import { encontrarModulo } from '../../../helpers/encontrarModulo';
import { useModalStore } from '../../../store/useModalStore';

export const Actions = ({ data, updated, deleted }) => {

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);
    // const { modalRef: { current: { handleOpen } } } = useContext(ModalsContext);
    const { openModal } = useModalStore();

    const actions = useMemo(() => {
        return encontrarModulo(permisos, 'canales')?.actions?.filter(a => a?.name !== 'crear')?.map(a => (rol?.includes('admin') || a?.active) ? a : null);
    }, []);

    // const openModal = (form) => handleOpen(form);

    const buttons = [
        { icon: <VisibilityOutlined color='action' fontSize='small' />, action: () => false },
        { icon: <EditOutlined color='action' fontSize='small' />, action: () => openModal(<UpdateChannelForm data={ data } action={ (e) => updated({ ...e, _id: data?._id }) } />)  },
        { icon: <DeleteOutlined color='action' fontSize='small' />, action: () => openModal(<CustomWarningDelete action={ () => deleted(data?._id) } />) }
    ];

    return (
        <>
            { actions?.map((a, i) => a && (
                <Tooltip title={ convertirLetraMayus(a?.name) }>
                    <IconButton aria-label="read" onClick={ buttons[i]?.action }>
                        { buttons[i]?.icon }
                    </IconButton>
                </Tooltip>
            ))}
        </>
    );
}